import { render, staticRenderFns } from "./BackgroundIcon.vue?vue&type=template&id=c6f2c3fe"
import script from "./BackgroundIcon.vue?vue&type=script&lang=js"
export * from "./BackgroundIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports